import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Button, { ButtonType } from '../general-components/Button';
import AuthContext from '../../store/auth-context';
import RIGHTS_KEYS from '../../constants/rights-keys';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

const GoToDocumentButton: React.FC<{
    implantId?: string;
    activeConfigId?: string;
    children?: React.ReactNode;
    className?: string;
}> = ({ implantId, activeConfigId, children, className }) => {
    const navigate = useNavigate();
    const context = useContext(AuthContext);

    // Only show if user has cptReporting right
    if (!context.orRights([RIGHTS_KEYS.cptReporting])) {
        return null;
    }

    const handleClick = () => {
        const params = new URLSearchParams();
        params.set('scenario', 'default');

        if (implantId) {
            params.set('implant', implantId);
        }

        if (activeConfigId) {
            params.set('activeConfig', activeConfigId);
        }

        navigate(`/manage-reports/new?${params.toString()}`);
        document.getElementById('page-container')?.scrollTo(0, 0);
    };

    return (
        <Button
            type={ButtonType.action}
            onClick={handleClick}
            className={className}
        >
            {children || (
                <>
                    <FontAwesomeIcon icon={faFileAlt} />
                    Start CPT Report
                </>
            )}
        </Button>
    );
};

export default GoToDocumentButton;
